import router from '@/router'
import loginStore from '../store/login'
import { BaseLoginService } from 'kuaidong-service'
import { loginRoute } from '../config/router/account'
import { AppUtil, BrowserUtil, RouterUtil } from 'kuaidong-lib'
import { wxAccountBindRoute } from '@/config/router/wxAccountBind'
import { Route, NavigationGuardNext, RawLocation } from 'vue-router'

export default class LoginService extends BaseLoginService {
  public static router = router

  public static async route(target: string) {
    location.href = target
  }

  public static setRouter(_router = this.router) {
    this.router = _router
  }

  public static buildWXWebOauthUrl(
    _route: { name?: string; path?: string },
    _query: { [index: string]: string } | null = null
  ): string {
    const targetStr = this.encodeWXWebOauthTargetHash(RouterUtil.buildUrlFromRoute(_route, _query, this.router))
    return `https://api.tiantiantiaosheng.com/api/ttts/wx_web_oauth_entry?target=${targetStr}&scope=snsapi_base`
  }

  public static async checkWXWebOauthTargetAndRedirect(href = location.href) {
    if (href && this.hasWXWebOauthTargetHash(href)) {
      location.replace(this.decodeWXWebOauthTargetHash(href))

      return true
    }

    return false
  }

  public static async login(_route?: Route) {
    if (!(await AppUtil.isUnderApp())) {
      // 当前页已经是登录页不做跳转
      if (!_route && RouterUtil.isCurRoute(loginRoute)) {
        return false
      }

      if (
        BrowserUtil.isWechat() &&
        !BrowserUtil.isWxWork() &&
        !BrowserUtil.isWeapp() &&
        (_route && _route.fullPath ? _route.fullPath.includes('wxpublic-stu') : location.href.includes('wxpublic-stu'))
      ) {
        let queryStr = ''

        if (_route && _route.fullPath) {
          queryStr = `${location.origin}${location.pathname}#${_route.fullPath}`
        } else {
          queryStr = location.href
        }

        await loginStore.loadUserInfo(queryStr)

        if (loginStore.isLogined) {
          return this.router.go(0)
        } else {
          return LoginService.wxLogin(_route)
        }
      } else {
        let queryStr: string

        if (_route && _route.fullPath) {
          queryStr = `${location.origin}${location.pathname}#${_route.fullPath}`
        } else {
          queryStr = location.href
        }

        this.router.replace({ name: loginRoute.name, query: { target: queryStr } })

        return true
      }
    }

    return false
  }

  public static async wxLogin(_route?: Route) {
    // 当前页已经是登录页不做跳转
    if (!_route && RouterUtil.isCurRoute(wxAccountBindRoute)) {
      return false
    }

    // 微信的登录地址, 微信登录之后固定跳转到当前页面
    // if (_replace) {
    location.replace(loginStore.url)
    // } else {
    //   location.href = `${process.env.VUE_APP_CRAZYROPE_API}/wx_web_oauth_entry?target=${queryStr}`
    // }
  }

  public static async needLogin(_route: Route) {
    if (RouterUtil.isForceAuth(_route)) {
      return true
    }

    if (_route.meta?.needLogin || _route.meta?.forceLogin) {
      return true
    }

    return false
  }

  public static async isLogined(_to?: Route, _from?: Route) {
    if (
      _to?.meta?.forceLogin &&
      _from?.name !== _to?.name && // from the same page
      _from?.name !== loginRoute.name // from login page
    ) {
      return false
    }

    return (await AppUtil.isUnderApp()) || !!AppUtil.getRequestToken()
  }

  public static async isWxLogined() {
    return loginStore.isLogined
  }

  public static async routerBeforeEachHook(_to: Route, _from: Route, _next: NavigationGuardNext<Vue>) {
    // Check if it is the first visit.
    if (!_from.name && _from.fullPath === '/') {
      if (await LoginService.checkWXWebOauthTargetAndRedirect()) {
        return _next(false)
      }
    }

    if (
      // Get open id always.
      (_to.meta?.needOpenid ||
        // Get open id when under wechat.
        (_to.meta?.needOpenidUnderWechat && BrowserUtil.isWechat())) &&
      !_to.query?.openid
    ) {
      _next(false)

      return location.replace(BaseLoginService.buildWXWebOauthUrl(_to, _to.query, this.router))
    }

    // 特定情况(eg: 小程序)传入token
    if (_to.query[this.RequestTokenQueryKey]) {
      AppUtil.setRequestToken(_to.query[this.RequestTokenQueryKey] as string)
    }

    if (!(await LoginService.needLogin(_to))) {
      return _next()
    }

    if (
      BrowserUtil.isWechat() &&
      !BrowserUtil.isWxWork() &&
      !BrowserUtil.isWeapp() &&
      _to.fullPath.includes('wxpublic-stu')
    ) {
      let queryStr = ''

      if (_to && _to.fullPath) {
        queryStr = `${location.origin}${location.pathname}#${_to.fullPath}`
      } else {
        queryStr = location.href
      }

      await loginStore.loadUserInfo(queryStr)

      if (loginStore.isLogined) {
        return _next()
      } else {
        _next(false)
        return LoginService.wxLogin(_to)
      }
    } else {
      if (await this.isLogined(_to, _from)) {
        if (RouterUtil.isForceAuth(_to)) {
          return _next(RouterUtil.removeForceAuthFlagFromRoute(_to) as RawLocation)
        }

        return _next()
      } else {
        _next(false)

        return LoginService.login(_to)
      }
    }
  }
}
